// Which conversations are muted right now, redrawn the moment a timed mute ends (Discord's "Muted until …").
import { useEffect, useMemo, useState } from "react";
import { isConversationMuted, nextMuteEnd, type Channel, type ServerNotify } from "@bloom/shared";

/** Muted channels and DMs (by id), from my mutes and the server's mute (which never covers DMs). */
export function useMutedIds(channels: Pick<Channel, "id" | "kind">[], mutes: Record<string, number>, server: ServerNotify): Set<string> {
  const [now, setNow] = useState(() => Date.now());
  const next = nextMuteEnd([...Object.values(mutes), server.mutedUntil], now);
  useEffect(() => {
    if (next === null) return;
    // setTimeout tops out at ~24.8 days; a longer mute just checks again then.
    const t = setTimeout(() => setNow(Date.now()), Math.min(next - Date.now() + 50, 2 ** 31 - 1));
    return () => clearTimeout(t);
  }, [next]);
  return useMemo(() => new Set(channels.filter((c) => isConversationMuted(c.kind, mutes[c.id], server, now)).map((c) => c.id)), [channels, mutes, server, now]);
}
